var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilePushNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FC8F37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 4H8.11111C7.81643 4 7.53381 4.12041 7.32544 4.33474C7.11706 4.54906 7 4.83975 7 5.14286V18.8571C7 19.1602 7.11706 19.4509 7.32544 19.6653C7.53381 19.8796 7.81643 20 8.11111 20H15.8889C16.1836 20 16.4662 19.8796 16.6746 19.6653C16.8829 19.4509 17 19.1602 17 18.8571V5.14286C17 4.83975 16.8829 4.54906 16.6746 4.33474C16.4662 4.12041 16.1836 4 15.8889 4ZM8.11111 5.14286H15.8889V15.4286H8.11111V5.14286ZM8.11111 18.8571V16.5714H15.8889V18.8571H8.11111Z",
    fill: "#FFF4F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.3H12.5V18.3H11.5V17.3Z",
    fill: "#FFF4F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePushNodeIcon);
export default __webpack_public_path__ + "static/media/mobilePushNodeIcon.78b82af35f976267a5440c94d445243f.svg";
export { ForwardRef as ReactComponent };